import { Outlet, createBrowserRouter } from 'react-router-dom';
import { protectedRoutes } from './protected';
import { publicRoutes } from './public';
import { ErrorHandler } from '@blackhyve/common';
import { BugsnagErrorBoundary } from 'features/bugsnag';

export const appRouter = createBrowserRouter([
  {
    path: '/',
    element: (
      <BugsnagErrorBoundary FallbackComponent={ErrorHandler}>
        <Outlet />
      </BugsnagErrorBoundary>
    ),
    children: [...protectedRoutes, ...publicRoutes],
  },
]);
